import {TimelineLite} from "gsap";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../core/reel/winpresentation/SimplePresentationRunner";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DFFSIntroRunner} from "../presentation/freespin/DFFSIntroRunner";
import {DumpsterFire} from "../DumpsterFire";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DumpsterFireGameMode} from "../server/DumpsterFireGameMode";

export class DFFSIdlePresentation implements FlowStatePresentation {

    private readonly _presentations: SimplePresentation[];
    private _flowStateController: FlowStateController;
    private _mainTl: TimelineLite;

    constructor() {
        this._presentations = [
            new DFFSIntroRunner(),
        ];
    }

    start(flowStateController: FlowStateController): void {
        this._mainTl = new TimelineLite({
            delay: 0.3,
            onStart: () => {
                DumpsterFire.winView.playNormalAnimationForAll();
            }
        });
        this._flowStateController = flowStateController;
        this._mainTl.add(() => {
            SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
        });
    }

    public complete() {
        if (DumpsterFire.model.initData.isRestoreState) {
            DumpsterFire.backgroundElements.setMode(DumpsterFire.model.data.nextMode);
            DumpsterFire.gameLogo.setMode(DumpsterFire.model.data.nextMode);
        }
        if (!DumpsterFire.model.isRestore && DumpsterFire.model.data.upgradedSymbols.length > 0) {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(DumpsterFire.model.gameData.freespinsLeft - 1);
        }
        SlotGame.apiPlugin.betHandler.zeroBet();
        this._flowStateController.finish();
    }

}